import React, { useEffect } from "react";
import {
  Card,
  CardHeader,
  CardContent,
  CircularProgress,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Typography,
  Box,
} from "@mui/material";
import { campaignModel } from "../../Interfaces";
import { useGetCampaignsQuery } from "../../Apis/campaignApi";
import { useDispatch } from "react-redux";
import { setCampaign } from "../../Storage/Redux/campaignSlice";
import { useNavigate } from "react-router-dom";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import CancelIcon from "@mui/icons-material/Cancel";

export default function CampaignList() {
  const { data, isLoading } = useGetCampaignsQuery(null);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  useEffect(() => {
    if (!isLoading && data?.result) {
      dispatch(setCampaign(data.result));
    }
  }, [isLoading]);

  const handleRowClick = (campaignId: number) => {
    navigate(`/Campaign/Details/${campaignId}`);
  };

  return (
    <Card sx={{
        borderRadius: 3,
        boxShadow: 3,
        overflow: "hidden",
      }}>
      <CardHeader
        sx={{background:"#f8f8f8"}}
        title={
          <Typography
            variant="h6"
            sx={{ color: "#eb3c96", fontWeight: "bold", letterSpacing: 0.5 }}
          >
            Campaigns List
          </Typography>
        }
      />
      <CardContent>
        {isLoading ? (
          <Box display="flex" justifyContent="center" py={4}>
            <CircularProgress />
          </Box>
        ) : data?.result?.length > 0 ? (
          <Table size="small" sx={{ cursor: "pointer" }}>
            <TableHead>
              <TableRow>
                <TableCell sx={{ fontWeight: 600 }}>#</TableCell>
                <TableCell sx={{ fontWeight: 600 }}>Name</TableCell>
                <TableCell sx={{ fontWeight: 600 }}>Start Date</TableCell>
                <TableCell sx={{ fontWeight: 600 }}>End Date</TableCell>
                <TableCell sx={{ fontWeight: 600 }}>Status</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {data.result.map((campaign: campaignModel, index: number) => (
                <TableRow
                  key={campaign.id}
                  hover
                  onClick={() => handleRowClick(campaign.id)}
                  sx={{
                    "&:hover": {
                      backgroundColor: "rgba(81, 35, 132, 0.05)",
                      transition: "0.2s",
                    },
                  }}
                >
                  <TableCell>{index + 1}</TableCell>
                  <TableCell>{campaign.name}</TableCell>
                  <TableCell>
                    {new Date(campaign.startDate).toLocaleDateString()}
                  </TableCell>
                  <TableCell>
                    {new Date(campaign.endDate).toLocaleDateString()}
                  </TableCell>
                  <TableCell>
                    {campaign.isActive ? (
                      <CheckCircleIcon color="success" />
                    ) : (
                      <CancelIcon color="error" />
                    )}
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        ) : (
          <Box textAlign="center" py={4}>
            <Typography variant="h6" color="error" fontFamily="monospace">
              <strong>No Campaigns Found</strong>
            </Typography>
          </Box>
        )}
      </CardContent>
    </Card>
  );
}
